import React from "react";
import { Text, Logo, RowContainer, Container, ChatContainer } from "../style";
import rip from "../../../static/rip.svg";
import ChatMessage from "../../ChatArea/ChatMessage";

const Dead = () => {
  return (
    <Container>
      <RowContainer>
        <Logo src={rip} alt="logo" />
        <Text>You're already dead</Text>
        <Text>Wait for the game to finish</Text>
      </RowContainer>
      <ChatContainer>
        <ChatMessage />
      </ChatContainer>
    </Container>
  );
};

export default Dead;
